export default __webpack_public_path__ + "static/media/how-it-works-2.4fc43362.png";